import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form-group text-cl" };
const _hoisted_2 = ["onUpdate:modelValue"];
const _hoisted_3 = ["value"];
const _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", null, _toDisplayString(_ctx.label), 1),
        _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-success ml-2",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.add && _ctx.add(...args)))
        }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fas fa-plus" }, null, -1)
        ])),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "",
                key: i
            }, [
                _createTextVNode(_toDisplayString(i + 1) + ". ", 1),
                _withDirectives(_createElementVNode("select", {
                    class: "mr-2",
                    "onUpdate:modelValue": ($event) => ((_ctx.modelValue[i]) = $event)
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableOptions(i), (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                            key: _ctx.optionLabelKey ? item[_ctx.optionLabelKey] : item,
                            value: _ctx.optionValueKey ? item[_ctx.optionValueKey] : item
                        }, [
                            (_ctx.optionLabelKey)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(item[_ctx.optionLabelKey]), 1)
                                ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(item), 1)
                                ], 64))
                        ], 8, _hoisted_3));
                    }), 128))
                ], 8, _hoisted_2), [
                    [_vModelSelect, _ctx.modelValue[i]]
                ]),
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-danger ml-2",
                    onClick: ($event) => (_ctx.remove(i))
                }, _cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "fas fa-minus" }, null, -1)
                ]), 8, _hoisted_4)
            ]));
        }), 128))
    ]));
}
